module.exports = __webpack_public_path__ + "img/bg.7380f604.jpg";